var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import ChevronDown from 'wix-ui-icons-common/on-stage/ChevronDownSmall';
import { TextButton, TextButtonPriority } from '../../TextButton';
import { classes, st } from './ReactionButton.st.css';
import { ReactionsDataHooks } from '../dataHooks';
var TIMER_DELAY = 500;
export var ReactionButton = React.forwardRef(function (_a, ref) {
    var className = _a.className, selectedReaction = _a.selectedReaction, active = _a.active, onTriggerReaction = _a.onTriggerReaction, onTriggerPopover = _a.onTriggerPopover, popoverTriggerAriaLabel = _a.popoverTriggerAriaLabel, mobile = _a.mobile, expanded = _a.expanded;
    var _b = React.useState(false), animate = _b[0], setAnimate = _b[1];
    var _c = React.useState(false), isTriggerVisible = _c[0], setTriggerVisibility = _c[1];
    var subTriggerRef = React.useRef();
    var triggerTimer = React.useRef();
    var documentListenerTimer = React.useRef();
    var isPressedKey = React.useRef(false);
    var rootRef = React.useRef();
    var animationFrame = React.useRef();
    var doesMainButtonTriggerPopover = mobile && !active;
    var ariaProps = doesMainButtonTriggerPopover
        ? {
            'aria-haspopup': 'menu',
            'aria-expanded': expanded,
        }
        : {
            'aria-pressed': active,
        };
    var clearTimer = function () { return clearTimeout(triggerTimer.current); };
    React.useImperativeHandle(ref, function () { return ({
        cancelPopover: clearTimer,
    }); }, []);
    var onAnimationEnd = function () {
        setAnimate(false);
    };
    var showTriggerButton = function () {
        setTriggerVisibility(true);
    };
    var hideTriggerButton = function () {
        // Don't hide if popover is open
        if (!expanded) {
            setTriggerVisibility(false);
        }
    };
    var onFocus = function () {
        if (isPressedKey.current) {
            cancelAnimationFrame(animationFrame.current);
            showTriggerButton();
        }
    };
    var onBlur = function () {
        if (isPressedKey.current &&
            !rootRef.current.contains(document.activeElement)) {
            animationFrame.current = requestAnimationFrame(function () {
                hideTriggerButton();
            });
        }
    };
    var onClick = function (e) {
        if (doesMainButtonTriggerPopover) {
            onTriggerPopover();
        }
        else {
            // prevent focus on button
            e.preventDefault();
            onTriggerReaction();
        }
    };
    var onMouseEnter = function () {
        triggerTimer.current = setTimeout(onTriggerPopover, TIMER_DELAY);
    };
    var onDocumentKeyDown = function () {
        isPressedKey.current = true;
        documentListenerTimer.current = requestAnimationFrame(function () { return (isPressedKey.current = false); });
    };
    React.useEffect(function () {
        if (active) {
            setAnimate(true);
        }
    }, [active, selectedReaction.id]);
    React.useEffect(function () {
        document.addEventListener('keydown', onDocumentKeyDown);
        return function () {
            clearTimer();
            cancelAnimationFrame(documentListenerTimer.current);
            document.removeEventListener('keydown', onDocumentKeyDown);
        };
    }, []);
    return (React.createElement("div", { onFocus: !mobile ? onFocus : undefined, onBlur: !mobile ? onBlur : undefined, ref: rootRef, className: st(classes.root, {
            defaultReaction: selectedReaction.id,
            active: active,
            animate: animate,
            visibleTrigger: isTriggerVisible,
        }, className) },
        React.createElement(TextButton, __assign({ className: classes.reactionButton, onClick: onClick, onMouseEnter: !mobile ? onMouseEnter : undefined, onMouseLeave: !mobile ? clearTimer : undefined }, ariaProps, { prefixIcon: React.cloneElement(selectedReaction.icon, {
                onAnimationEnd: onAnimationEnd,
            }), priority: TextButtonPriority.secondary, "data-hook": ReactionsDataHooks.TriggerButton + " " + (active ? ReactionsDataHooks.HasReaction : '') }),
            React.createElement("span", { "data-hook": ReactionsDataHooks.ReactionLabel }, selectedReaction.label)),
        !mobile ? (React.createElement("button", { className: classes.popoverTrigger, onClick: onTriggerPopover, ref: subTriggerRef, "aria-label": popoverTriggerAriaLabel, "aria-haspopup": "menu", "aria-expanded": expanded, "data-hook": ReactionsDataHooks.SubTriggerButton },
            React.createElement(ChevronDown, null))) : null));
});
//# sourceMappingURL=ReactionButton.js.map